import qs from 'qs'

// 打开起点qq
export const openQQ = () => {
  window.open('https://wpa1.qq.com/yGWcFLfo?_type=wpa&qidian=true')
}

/**
 * @description: try catch
 * @param {function} 需要执行逻辑的函数
 * @param {any} 执行函数的参数
 * @return: array: array[0]: 错误 array[1]: 结果
 */
export async function tryCatch() {
  const args = Array.from(arguments)
  const asyncFunc = args.shift()
  try {
    const res = await asyncFunc(...args)
    return [null, res]
  } catch (e) {
    return [e, null]
  }
}

// 删除某个query
export function removeQuery(key) {
  const search = location.search
  if (!search) return
  const query = qs.parse(search.substr(1))
  Reflect.deleteProperty(query, key)
  const newSearch = qs.stringify(query) ? `?${qs.stringify(query)}` : ''
  history.replaceState({}, '', `${location.pathname}${newSearch}`)
}

// 判断设备类型
export function _isMobile() {
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}



export function handleScroll(num) {
  const scrollTop =
    document.documentElement.scrollTop || document.body.scrollTop

  const windowHeight =
    document.documentElement.clientHeight || document.body.clientHeight

  const scrollHeight =
    document.documentElement.scrollHeight || document.body.scrollHeight

  const scrollBottom = scrollHeight - windowHeight - scrollTop
  if (scrollBottom <= num) {
    return true
  } else {
    return false
  }
}